import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  Book,
  ExaminationSession,
  Exercise,
  Paragraph,
  PractiseHomeCard,
  PractiseOverviewCard,
  PractiseType,
  Video,
} from '@lyceo/lyceo-pupil-app/practise/util-models';
import { AutocompleteOption, ExerciseResult } from '@lyceo/shared/util-models';

export const PractiseOverviewPageActions = createActionGroup({
  source: 'Practise Overview Page',
  events: {
    'Init': emptyProps(),
    'Segment Clicked': props<{ practiseType: PractiseType }>(),
    'Select Book Clicked': props<{ scopeId: string }>(),
    'Card Clicked': props<{ card: PractiseOverviewCard }>(),
  },
});

export const PractiseBookPageActions = createActionGroup({
  source: 'Practise Book Page',
  events: {
    'Init': emptyProps(),
    'Paragraph Clicked': props<{ paragraph: Paragraph }>(),
    'Pagination Paragraph Clicked': props<{ paragraph: Paragraph }>(),
    'Pagination Last Paragraph Clicked': props<{ paragraph: Paragraph }>(),
    'Pagination Final Exam Clicked': props<{ book: Book }>(),
    'Search Paragraph Clicked': props<{
      item: AutocompleteOption | undefined;
    }>(),
    'Search Paragraph Value': props<{ searchString: string }>(),
    'Final Exam Clicked': props<{ book: Book }>(),
    'Read Theory Clicked': props<{ readTheory: boolean }>(),
    'Exercise Clicked': props<{ exercise: Exercise }>(),
    'View Exercise Result Clicked': props<{
      exerciseResult: ExerciseResult<ExaminationSession>;
    }>(),
    'Final Exam Exercise Clicked': props<{ book: Book }>(),
    'Video Watched': props<{ video: Video }>(),
    'Video Play Clicked': props<{ video: Video }>(),
  },
});

export const PractiseHomePageActions = createActionGroup({
  source: 'Practise Home Page',
  events: {
    'Empty Card Clicked': emptyProps(),
    'Card Clicked': props<{ card: PractiseHomeCard }>(),
  },
});
